module.exports = __webpack_public_path__ + "static/youtube-adv-9a31cdd658092bbf57344121a903f312.png";